// extracted by mini-css-extract-plugin
export var columnList = "_c0-0";